import React from "react";

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 overflow-x-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">


          {/* LEFT SIDE – OVAL IMAGES */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">

            {/* Image 1 */}
            <div className="w-28 sm:w-32 lg:w-36 h-72 sm:h-96 lg:h-[420px] rounded-full overflow-hidden shadow-lg">

              <img
                src="/about1.webp"
                alt="Team work"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Image 2 */}
            <div className="w-28 sm:w-32 lg:w-36 h-72 sm:h-96 lg:h-[420px] rounded-full overflow-hidden shadow-lg">

              <img
                src="/about2.webp"
                alt="Team discussion"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Image 3 */}
            <div className="w-28 sm:w-32 lg:w-36 h-72 sm:h-96 lg:h-[420px] rounded-full overflow-hidden shadow-lg">

              <img
                src="/about3.jpg"
                alt="Presentation"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* RIGHT SIDE – CONTENT */}
          <div>
            <p className="text-orange-500 font-semibold mb-3">
              What Drives Us
            </p>

            <h2 className="text-4xl lg:text-5xl font-bold leading-tight mb-6">
              Empowering Ideas <br /> with Technology
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed mb-10 max-w-xl">
              We are specialized in delivering innovative IT solutions tailored
              to your business needs. Our team is committed to client success
              and excellence, leveraging emerging technologies to craft
              solutions that drive growth and efficiency.
            </p>

            {/* FEATURES */}
            <div className="flex gap-4 flex-wrap">
              <div className="flex items-center gap-3 border rounded-lg px-5 py-3">
                <span className="text-orange-500 font-bold">✓</span>
                <span className="font-medium text-gray-800">
                  Scalable for Any Business
                </span>
              </div>

              <div className="flex items-center gap-3 border rounded-lg px-5 py-3">
                <span className="text-orange-500 font-bold">✓</span>
                <span className="font-medium text-gray-800">
                  Solutions Without Limits
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
